export enum SPACE_TYPE {
    DISABLED = 'disabled',
    REGULAR = 'regular',
    MOTORCYCLE = 'motorcycle',
    FAMILY = 'family',
    BUS = 'bus',
    BIG = 'big',
}

export enum DISALLOW_USAGE_FOR {
    CLIENT = 'client',
    VIP = 'vip',
    RESIDENT = 'resident',
    STAFF = 'staff',
    SERVICE = 'service',
    RESERVATION = 'reservation',
    SUBSCRIPTION = 'subscription',
}

export type Space = {
    id: string;
    created_at: string;
    modified_at: string;
    number: string;
    is_free: boolean;
    is_reserved: boolean;
    type: SPACE_TYPE;
    disallow_usage_for?: DISALLOW_USAGE_FOR;
    zone: string;
};
